module.exports = __webpack_public_path__ + "img/prod-2.0f7c5402.png";